module.exports = __webpack_public_path__ + "img/132.ededd307.jpg";